import { organizationMemberListSchema, organizationMemberSchema, invitedMemberSchema, newOrganizationMemberSchema, personalKeyMemberListSchema, } from '../contracts/organization-members';
import { organizationIdSchema, } from '../contracts/organizations';
import { parseSchema } from '../errors';
/**
 * List members of an organization
 */
export async function listOrganizationMembers(client, organizationId, options = {}) {
    const validatedId = parseSchema(organizationIdSchema, organizationId);
    const url = `/organizations/${validatedId}/members`;
    const response = options.fresh
        ? await client.get(url, { params: { fresh: 'true' } })
        : await client.get(url);
    return parseSchema(organizationMemberListSchema, response);
}
/**
 * Add a new member to an organization
 */
export async function addOrganizationMember(client, organizationId, memberData) {
    const validatedId = parseSchema(organizationIdSchema, organizationId);
    const validatedData = parseSchema(newOrganizationMemberSchema, memberData);
    const response = await client.post(`/organizations/${validatedId}/members`, validatedData);
    return parseSchema(invitedMemberSchema, response);
}
/**
 * Re-send a pending or expired invitation to a previously-invited user
 * (KIR-4038). Rotates the invite token (invalidating the old link) and re-sends
 * the invitation email. Owner/manager only.
 */
export async function resendOrganizationInvite(client, organizationId, userId) {
    const validatedOrgId = parseSchema(organizationIdSchema, organizationId);
    const response = await client.post(`/organizations/${validatedOrgId}/members/${encodeURIComponent(userId)}/resend`);
    return parseSchema(invitedMemberSchema, response);
}
/**
 * Invite a Discovered user (KIR-3908), folding the lightweight row into a full
 * account while preserving its findings/alerts. `userId` is the internal user
 * id from the members list.
 */
export async function inviteDiscoveredUser(client, organizationId, userId) {
    const validatedId = parseSchema(organizationIdSchema, organizationId);
    const response = await client.post(`/organizations/${validatedId}/members/discovered/${userId}/invite`);
    return parseSchema(invitedMemberSchema, response);
}
/**
 * Remove a member from an organization
 */
export async function removeOrganizationMember(client, organizationId, userId) {
    const validatedOrgId = parseSchema(organizationIdSchema, organizationId);
    await client.delete(`/organizations/${validatedOrgId}/members/${userId}`);
}
/**
 * List members still using a personal API key (KIR-3786). Owner-only.
 */
export async function listMembersOnPersonalKeys(client, organizationId, options = {}) {
    const validatedId = parseSchema(organizationIdSchema, organizationId);
    const url = `/organizations/${validatedId}/members/personal-keys`;
    const response = options.fresh
        ? await client.get(url, { params: { fresh: 'true' } })
        : await client.get(url);
    return parseSchema(personalKeyMemberListSchema, response);
}
/**
 * Update a member's role in an organization
 */
export async function updateOrganizationMemberRole(client, organizationId, userId, role) {
    const validatedOrgId = parseSchema(organizationIdSchema, organizationId);
    const response = await client.put(`/organizations/${validatedOrgId}/members/${userId}/role`, { role });
    return parseSchema(organizationMemberSchema, response);
}
//# sourceMappingURL=members.js.map